export interface InputProps {
  label: string
  type?: string
  error?: string
  value: string
  onChange: (val: string) => void
  className?: string
}

export function Input({
  label,
  error,
  type = 'text',
  value,
  className = '',
  onChange,
}: InputProps): React.ReactElement {
  return (
    <label className={`block ${className}`}>
      <div className="mb-4">
        {label}
        {error && <span>: {error}</span>}
      </div>
      <input
        className="block w-full mb-4 rounded bg-blue-light p-4 outline-none"
        onChange={(evt) => onChange(evt.currentTarget.value)}
        type={type}
        value={value}
      />
    </label>
  )
}
